/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";
import Terms from "./Terms";

/* Render Terms app into the pug template */
function render(props) {
  hydrate(<Terms {...props} />, document.getElementById("react"));
}

render(window.reactProps);
